import {ServerResponse} from './types.model';
import {SupportedLanguages} from './language.model';

export interface IUserData {
  username: string;
}

export interface AuthResponse extends ServerResponse {
  user: IUserData;
  token: string;
  expires: number;
}

export const emptyUserData: IUserData = {
  username : '',
}
